import styled from 'styled-components';

export const DataGetter = styled.div`
  background: ${(props) => (props.highlight ? '#F7D4F3' : '#fbfbfd')};
  border-radius: 5px;
  padding-left: 10px;
  min-height: 38px;
  display: flex;
  flex-grow: 1;
  > div {
    width: 100%;
  }
  .value_selector__control {
    background: none !important;
    border-bottom: none !important;
    width: 100%;
  }
  .Superops-Connected {
    padding-top: 0 !important;
  }
  .Superops-TextField {
    background: transparent;
    min-height: 38px;
  }
  .Superops-TextField__Input {
    padding-bottom: 0;
    border-bottom: 0 !important;
  }
  .Superops-TextField--multiline > .Superops-TextField__Input {
    padding-top: 6px;
  }
`;

export const TimeCollector = styled.div`
  background: ${(props) => (props.highlight ? '#F7D4F3' : '#fbfbfd')};
  border-radius: 5px;
  padding-left: 10px;
  min-height: 38px;
  min-width: 60px;
  .Superops-TextField__Prefix,
  .Superops-TextField__Suffix {
    border-bottom: none !important;
    background: none !important;
  }
  .value_selector__control {
    background: none !important;
    border-bottom: none !important;
  }
  .Superops-Connected {
    padding-top: 0 !important;
  }
  .Superops-TextField {
    background: transparent;
    min-height: 38px;
  }
  .Superops-TextField__Input {
    padding-bottom: 0;
    border-bottom: 0 !important;
  }
  .Superops-TextField--multiline > .Superops-TextField__Input {
    padding-top: 6px;
  }
`;

export const DateWrapper = styled.div`
  background: #fbfbfd;
  border-radius: 5px;
  padding-left: 5px;
  height: 38px;
  transition: background 200ms linear;
  .react-datepicker__input-container > input,
  .react-datepicker__input-container,
  .react-datepicker-wrapper {
    height: 100%;
    width: 100%;
  }
  .react-datepicker__input-container > input {
    font-weight: 400 !important;
    border-width: none;
    border: none;
    border-bottom: none !important
    margin-right: 14px;
    padding: 6px;
    height: 100%;
    font-size: 14px;
  }
  .react-datepicker__tab-loop {
    position: relative;
  }
`;

export const TimerCell = styled.div`
  background: ${(props) => (props.highlight ? '#F7D4F3' : '#fbfbfd')};
  border-radius: 5px;
  padding: 0 10px;
  min-height: 38px;
  transition: background 200ms linear;
`;

export const Timer = styled.div`
  .blink {
    animation: blink 1s cubic-bezier(0.36, 0.07, 0.19, 0.97) infinite;
  }
`;

export const Wrapper = styled.div`
  background: ${(props) =>
    props.highlight
      ? 'linear-gradient(105.43deg, #ffd0ec 1.25%, #e2a4ff 99.99%), #ffffff'
      : 'transparent'};
  border-radius: 0 0px 10px 10px;
  transition: all 200ms linear;
  opacity: ${(props) => (props.disabled ? '0.3' : '1')};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'all')};
`;

export const IconHolder = styled.div`
  padding: 5px;
  background: ${(props) => (props.selected ? '#fff4ce' : '#fff')};
  border: 1px solid black;
  border-radius: 50%;
  height: 32px;
  cursor: pointer;
  transition: background 200ms linear;
`;
